import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, keywords, canonical, type = "website" }) => {
  const siteTitle = "Elevante.ai";
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} — AI Learning Platform for Universities & Enterprises`;
  const defaultDescription = "Elevante.ai is the leading AI learning platform enabling hands-on AI skilling for universities and enterprises. Lab-based AI courses, industry simulations, and customisable training programs.";
  const desc = description || defaultDescription;
  const url = canonical || "https://elevante.ai";
  const ogImage = "https://customer-assets.emergentagent.com/job_laughing-sinoussi-3/artifacts/42ty74qh_Frame%201000005856%20%281%29.png";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
